import { render, staticRenderFns } from "./ButtonStandard.vue?vue&type=template&id=f694cc7a&scoped=true"
import script from "./ButtonStandard.vue?vue&type=script&lang=js"
export * from "./ButtonStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f694cc7a",
  null
  
)

export default component.exports